import React, { useState } from 'react';

const OrderItemsTable = ({ order }) => {
  // 图片放大预览：只在这个组件内部管理，点哪张就存哪张的地址，
  // null 表示没有在预览。不用额外做成一个全局共用的弹窗组件——
  // 这个功能足够简单，放在本地状态里就够了，不用为了它去改父组件的结构
  const [previewSrc, setPreviewSrc] = useState(null);

  return (
    <>
      <table className="w-full text-sm">
        <thead>
          <tr className="text-gray-500">
            <th className="text-left py-1">商品</th>
            <th className="text-right py-1">单价</th>
            <th className="text-right py-1">数量</th>
            <th className="text-right py-1">小计</th>
          </tr>
        </thead>
        <tbody>
          {order.items && order.items.map(item => (
            <tr key={item.id} className="border-t border-gray-100">
              <td className="py-2">
                <div className="flex items-center space-x-2">
                  {/* 商品缩略图：点击放大查看，方便配货时核对商品是不是拿对了 */}
                  <img
                    src={item.image || '/default-product.png'}
                    alt=""
                    className="w-10 h-10 rounded-lg object-cover bg-gray-100 flex-shrink-0 cursor-pointer hover:opacity-80"
                    onClick={() => setPreviewSrc(item.image || '/default-product.png')}
                  />
                  <span>{item.product_name}</span>
                </div>
              </td>
              <td className="text-right py-2">${parseFloat(item.unit_price).toFixed(2)}</td>
              <td className="text-right py-2">x{item.quantity}</td>
              <td className="text-right py-2">${parseFloat(item.subtotal).toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr className="border-t border-gray-200">
            <td colSpan="3" className="py-2 text-gray-500">配送费</td>
            <td className="text-right py-2">${parseFloat(order.delivery_fee || 0).toFixed(2)}</td>
          </tr>
          <tr className="font-semibold">
            <td colSpan="3" className="py-2">合计</td>
            <td className="text-right py-2">${parseFloat(order.total_amount).toFixed(2)}</td>
          </tr>
        </tfoot>
      </table>

      {/* 图片放大弹窗：点缩略图触发，点弹窗任意位置关闭，不需要额外的关闭按钮 */}
      {previewSrc && (
        <div
          className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 cursor-zoom-out"
          onClick={() => setPreviewSrc(null)}
        >
          <img
            src={previewSrc}
            alt=""
            className="max-w-[90vw] max-h-[90vh] rounded-lg object-contain"
          />
        </div>
      )}
    </>
  );
};

export default OrderItemsTable;